import { render, staticRenderFns } from "./OSComponent.vue?vue&type=template&id=4acfa1e4&scoped=true&"
import script from "./OSComponent.vue?vue&type=script&lang=js&"
export * from "./OSComponent.vue?vue&type=script&lang=js&"
import style0 from "./OSComponent.vue?vue&type=style&index=0&id=4acfa1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acfa1e4",
  null
  
)

export default component.exports